export default __webpack_public_path__ + "static/media/download.7b438b49.svg";